import CustomImage from '../Antd/Image';
import CustomTooltip from '../Antd/Tooltip';


const CustomMediaViewer = ({ src, alt, ...props }) => {

  const isPdf = src?.toLowerCase().endsWith('.pdf');

  if (isPdf) {
    return (
      <div style={{ width: '100%', height: '500px', border: '1px solid #d9d9d9', borderRadius: '2px' }}>
        <CustomTooltip title="El archivo es un PDF. Haz clic para descargarlo.">
          <iframe
            src={src}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title={alt || 'Visor de PDF'}
            {...props}
          />
        </CustomTooltip>
      </div>
    );
  }

  return <CustomImage src={src} alt={alt} {...props} />;
};

export default CustomMediaViewer;